<template>
  <div class="offers-page--main-wrapper product-desc">
    <top-header></top-header>

    <div class="offers-page--outer-wrapper mt-25" >
		<!--<div class="collections-page--header-wrapper">
        <b-container>
         
          <b-img style="width:100%" 
            :src="$root.MEDIAPATH+'category-banner/cosmetics.jpg'"
            alt=""
            class="offers-page-feature-banner offers-page-feature-banner--cosmetics"
          ></b-img>
        </b-container>
      </div>  -->

      <b-container>
		
	   <TopBrands></TopBrands>
	    <h3 class="mt-4 pb-2"  ref="porto">COUPONS</h3>
		<!-- window.location.hash = '#tries'; -->
	   <coupon-listing></coupon-listing>
	   
	    <h3 class="mt-4 pb-2">OFFERS BY BRANDS</h3>
	   <Offers-by-category></Offers-by-category>
	   
	    <Offers></Offers>
        <!--<span class="product-txt d-block text-center ">All Offers</span> -->
		<!-- <b-container fluid class="p-0 mt-4" >
		
		<b-tabs content-class="mt-3" fill pills  class="profileTab">
			<b-tab title="Top Offers" active>
				<h4 class="text-center pt-4 my-4">TOP OFFERS</h4>
				<b-row class="mb-4">
					<b-col lg="12" md="6" sm="12">
					
						
						<b-row class="mb-4" v-for="rowIdx in Math.ceil(toporders.length / columInarow)" :key="rowIdx">
							 <b-col   v-for="item in toporders.slice(columInarow * (rowIdx - 1), columInarow * rowIdx)" :key="item"> 
							
								<b-link :href="'/brand/'+item.urlslug"> 
									<div class="pageview">
										<b-img :src="$root.MEDIAAPI+'tool/get_image?size=400x400&src='+$root.MEDIAPATH+'brands/'+item.brand_logo"  fluid-grow alt="Fluid-grow image" class="moreOfferImgHeight"></b-img>
										
										<div class="imginfo">
											<p class="title">Upto {{item.topdiscount || 0}}% OFF</p>
											
										</div>
										
									</div>
								</b-link>
								
							</b-col>
						
						</b-row >
						
						
						
					
						
						
					</b-col>
					
				</b-row>

			
			</b-tab>

			<b-tab title="All Offers" >
			<h4 class="text-center pt-4 my-4">ALL OFFERS </h4>
			
					<b-row class="mb-4">
						<b-col lg="12" md="6" sm="12">
						
							
							<b-row class="mb-4" v-for="rowIdx in Math.ceil(allOffers.length / columInarow)" :key="rowIdx">
								 <b-col   v-for="item in allOffers.slice(columInarow * (rowIdx - 1), columInarow * rowIdx)" :key="item"> 
								
									<b-link :href="'/brand/'+item.urlslug">
										<div class="pageview">
											<b-img :src="$root.MEDIAAPI+'tool/get_image?size=400x400&src='+$root.MEDIAPATH+'brands/'+item.brand_logo"  fluid-grow alt="Fluid-grow image" class="moreOfferImgHeight"></b-img>
											
											<div class="imginfo ">
												<p class="title">Upto {{item.topdiscount || 0}}% OFF</p>
												
											</div>
											
										</div>
									</b-link>
									
								</b-col>
							
							</b-row >
							
							
							
						
							
							
						</b-col>
						
					</b-row>

						
					
			</b-tab>
			<b-tab title="Clearance ">
				<h4 class="text-center pt-4 my-4">CLEARANCE</h4>
					<b-row class="mb-4">
						<b-col lg="12" md="6" sm="12">
						
							
							<b-row class="mb-4" v-for="rowIdx in Math.ceil(toporders.length / columInarow)" :key="rowIdx">
								 <b-col   v-for="item in toporders.slice(columInarow * (rowIdx - 1), columInarow * rowIdx)" :key="item"> 
								
									<b-link :href="'/brand/'+item.urlslug">
										<div class="pageview">
											<b-img :src="$root.MEDIAAPI+'tool/get_image?size=400x400&src='+$root.MEDIAPATH+'brands/'+item.brand_logo"  fluid-grow alt="Fluid-grow image" class="moreOfferImgHeight"></b-img>
											
											<div class="imginfo">
												<p class="title">Upto {{item.topdiscount || 0}}% OFF</p>
												
											</div>
											
										</div>
									</b-link>
									
								</b-col>
							
							</b-row >
							
							
							
						
							
							
						</b-col>
						
					</b-row>

			
			
			</b-tab>
			
		  </b-tabs>
		
		
		</b-container> -->
		
		
      </b-container>
    </div>
		 <top-footer></top-footer>
  </div>
</template>

<script>
import '@/assets/offers.scss';
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import TopBrands from "@/components/TopBrands.vue";
import Offers from "@/components/Offers.vue";
import Offersbycategory from "@/components/Offers-by-category.vue";
import Couponlisting from "@/components/coupon-listing.vue";
//import Footer from "@/components/footer.vue";
/* import ProductRating from "@/components/product-rating.vue";
import ProductPrice from "@/components/product-price.vue";
import ProductOffer from "@/components/product-offer.vue";
import AddtocartButton from "@/components/addtocartButton.vue"; */
//import RangeSlider from 'vue-range-slider';
// you probably need to import built-in style

export default {
  name: "offers-page-cosmetics",
  
	props: {
    WEBURL: { type: String },
		metadata: { type: Object },
	},
	
	beforeCreate: function () {
    document.body.className = "offers-page-cosmetics";
  }, 
   watch: {
      '$route' (to, from) {
		console.log('to'+to.path+'--from-'+from);
		if (to.path) {
			//this.refressAllVariable();
			//this.initload();
			 window.location.reload();
			 //this.$forceUpdate();
		
		}
        
      }
    },
  components: {
    "top-header": Header,
    "top-footer": Footer,
	TopBrands,
	Offers,
	"Offers-by-category": Offersbycategory,
	"coupon-listing": Couponlisting,
   // "top-footer": Footer,
   
    /*RangeSlider,*/
  },
  mounted(){
		this.initload();
		
	  var routeName = this.$route.name;
		console.log(routeName)
		if(routeName=='Offers-coupon'){
			this.scrollMeTo('porto');
		}
	  if(window.innerWidth < 700){
			this.columInarow  = 2;
			
		 }
	},
  data() {
    return { 
		topoffersurl: this.$root.WEBURL+'gettopoffers',
		toporders:[],
		allOffers:[],
		columInarow:3,
		mobilfilterlist: 0,
		breadcrumbItems: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Offers",
          active: true,
        },
      ],
	 // pageData:[{"col":3,"children":{"c1":{"title":"title1","subtitle":"subtitle1","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c2":{"title":"title2","subtitle":"subtitle2","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c3":{"title":"title3","subtitle":"subtitle3","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."}}},{"col":2,"children":{"c1":{"title":"title1","subtitle":"subtitle1","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c2":{"title":"title2","subtitle":"subtitle2","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."}}},{"col":2,"children":{"c1":{"title":"title1","subtitle":"subtitle1","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."}}}], 
	  pageData:[{"col":3,"children":{"c1":{"title":"title1","subtitle":"subtitle1","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c2":{"title":"title2","subtitle":"subtitle2","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c3":{"title":"title3","subtitle":"subtitle3","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c4":{"title":"title4","subtitle":"subtitle3","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."}}},{"col":2,"children":{"c1":{"title":"title1","subtitle":"subtitle1","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."},"c2":{"title":"title2","subtitle":"subtitle2","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry."}}},{"col":2,"children":{"c1":{"title":"title1","subtitle":"subtitle1","content":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."}}}],
	
    };
  },
  methods: {
		initload(){
			var self = this;
			self.axios.post(self.topoffersurl, {
                accesskey: self.$root.customer_info.access_key,
                /*category: this.$route.params.category,
                subcategory: categieyName,
                filter:self.filterQuery,
                page:self.nextPage*/
			}).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.toporders=[];
					self.allOffers=[];
					var topOffer =  response.data.result.topOffers;
					//self.toporders =  response.data.result.topOffers;
					//self.allOffers =  response.data.result.allOffers;
					var allOffers =  response.data.result.allOffers;
					//console.log(response);
					topOffer.forEach(item => {
								if(item.topdiscount>0 && item.topdiscount!=null){
								self.toporders.push(item);
								}

						});
						
						allOffers.forEach(item => {
								if(item.topdiscount>0 && item.topdiscount!=null){
								self.allOffers.push(item);
								}

						});
					
				}
			}).catch(function (error) {
				alert(error);
			});
		
		
		},
		scrollMeTo(refName) {
			var element = this.$refs[refName];
			var top = element.offsetTop;

			window.scrollTo(0, top);
		  }
		
	},
  metaInfo() {
        //console.log('-------META INFO-------');
		//console.log('dev'+JSON.stringify(this.metaInfoList[this.$route.params.category]));
		let titleMeta = 'Alluraa';
		let descriptionMeta ='Alluraa';
		/*if(this.metaInfoList[this.$route.params.category]){
		let getTitle = this.metaInfoList[this.$route.params.category].title;
		let getdescription = this.metaInfoList[this.$route.params.category].description;
		
			if(getTitle){
				titleMeta = getTitle;
			}
			if(getdescription){
				descriptionMeta = getdescription;
			}
		} */
		
		
		return{
			
			title: titleMeta,
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				/* { name: 'keywords', content: this.metadata.keywords }, */
				{ name: 'description', content: descriptionMeta},
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>

<style scoped lang="scss">

</style>